/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#change-password-content[_ngcontent-%COMP%]{width:350px;height:400px;border:none;display:block;overflow:hidden;margin-left:auto;margin-right:auto}"];
export { styles as styles };
